import React, {useState} from 'react';
import { useScrollPosition } from '../../hooks/ScrollPosition';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

import {
  getCustomer
} from "../helpers";

const Header = () => {

  let userId = getCustomer();
  const navigate = useNavigate();
  const scrollPosition = useScrollPosition();

  const [openMenu, setOpenMenu] = useState(false)

  let navHeightChange = false
  if (scrollPosition > 102){
    navHeightChange = true
  }else{
    navHeightChange = false
  }

  const logout = (ev) => {
    setOpenMenu(false)
    localStorage.clear();
    window.location.href = "/";
  }

  return(
    <div className="custom--header">
      <div className={navHeightChange ? "header--container header-scroll" : "header--container"}>
        <div>
          <div>
            <div className="logo--section">
              <div className="logo--container">
                <img src={process.env.REACT_APP_URL_DOMAIN_NAME === `dev` ? `https://marquet-public-assets.s3.amazonaws.com/subscriptions-portal/Marquet_logo_SP.png` :`https://prod-marquet-public-assets.s3.amazonaws.com/subscriptions-portal/Marquet_logo_SP.png`}/>
              </div>
            </div>
            {/*<div className="items--section">
              <nav>
                <ul>
                  <li>
                    <a href="#">
                      <span>Home</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Platform
                        <span></span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Resources
                        <span></span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>Contact Us</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>*/}
            {userId !== ""?
              <div className="login--section">
                <div className={openMenu === true ? "menu--button menu--open" : "menu--button"} onClick={ev=>{setOpenMenu(!openMenu)}}>
                  <div className="hamburger--slice"></div>
                  <div className="hamburger--slice"></div>
                  <div className="hamburger--slice"></div>
                </div>
                <div className={openMenu === true ? "menu--mobile" : "menu--mobile menu--collapse" }>
                  <div className="menu--mobile--container">
                    <ul>
                      <li>
                        <Link className="menu--item" to='/myAccount' onClick={ev => { setOpenMenu(false) }}>
                          My Account
                        </Link>
                      </li>
                      <li>
                        <Link className="menu--item" to='/mySubscriptions' onClick={ev => { setOpenMenu(false) }}>
                          Subscriptions
                        </Link>
                      </li>
                      <li>
                        <Link className="menu--item" to='/myVirtualSpaces' onClick={ev => { setOpenMenu(false) }}>
                          My Virtual Spaces
                        </Link>
                      </li>
                      <li>
                        <Link className="menu--item" to='/billingActivity' onClick={ev => { setOpenMenu(false) }}>
                          Billing &amp; Payments
                        </Link>
                      </li>
                      <li>
                        <a type="button" onClick={ev => logout(ev)} className="menu--item">Logout</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>:
              <div className="login--section">
                <a type="button" onClick={ev => { navigate("/") }}>
                  <span>Sign In</span>
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
export default Header;